import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StyledButton from './styled-components/StyledButton';

const ButtonText = styled.span`
  height: 23px;
  /* color: #fff; */
  font-size: inherit;
  font-weight: 500;
  line-height: 23px;
  text-align: center;
`;

const Button = ({
  background,
  border,
  color,
  content,
  customButton,
  disabled,
  fontSize,
  fullHeight,
  fullWidth,
  noTopMargin,
  primary,
  minWidth,
  ...props
}) => (
  <StyledButton
    background={background}
    border={border}
    color={color}
    customButton={customButton}
    disabled={disabled}
    fontSize={fontSize}
    fullHeight={fullHeight}
    fullWidth={fullWidth}
    noTopMargin={noTopMargin}
    primary={primary}
    minWidth={minWidth}
    type="button"
    {...props}
  >
    <ButtonText>{content}</ButtonText>
  </StyledButton>
);

Button.defaultProps = {
  primary: false,
  disabled: false,
  fullHeight: false,
  fullWidth: false,
  customButton: false,
  border: null,
  fontSize: null,
  background: null,
  color: null,
  noTopMargin: false,
  minWidth: null,
};

Button.propTypes = {
  background: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  customButton: PropTypes.bool,
  disabled: PropTypes.bool,
  fontSize: PropTypes.string,
  fullHeight: PropTypes.bool,
  fullWidth: PropTypes.bool,
  noTopMargin: PropTypes.bool,
  primary: PropTypes.bool,
  minWidth: PropTypes.string,
};

export default Button;
